var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.saved)?_c('record',{attrs:{"settings":_vm.settings,"name":_vm.name,"onUpload":_vm.saveCode}}):_vm._e(),(_vm.saved)?_c('success',{attrs:{"code":_vm.saved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }